import { memo } from "react";

import { Container, makeStyles, Typography } from "@material-ui/core";

import { CircularProggressIndicator } from "../components-atoms/CircularProggressIndicator";
import { InfoCard } from "../components-molecules/InfoCard";
import { ShopRegionHeadline, ThreeDotMenuItem } from "../components-atoms";
import { useHistory } from "react-router";
interface IProps {
  loading?: boolean;
  data: Array<any>;
  sortType?: number;
  bottomTextCreator: any;
  topTextCreator: any;
  pathCreator?: any;
  threeDotMenuItems?: Array<any>;
  headlineTypeSingular?: string;
  headLineTypePlural?: string;
}
export const ClusteredList = memo((props: IProps) => {
  const classes = useStyles();
  const history = useHistory();
  const {
    loading,
    data,
    bottomTextCreator,
    topTextCreator,
    pathCreator,
    threeDotMenuItems,
  } = props;

  return (
    <div className={classes.component}>
      {loading ? (
        <CircularProggressIndicator />
      ) : data.length === 0 ? (
        <Container className={classes.noRecordsFound}>
          <Typography variant="body1" component="span">
            No records found
          </Typography>
        </Container>
      ) : (
        <>
          {data &&
            data.length > 0 &&
            data.map((item: any, index: any) => (
              <div key={index}>
                {item?.[1]?.length > 0 && (
                  <ShopRegionHeadline
                    key={index}
                    headlineTypeSingular={props.headlineTypeSingular}
                    headLineTypePlural={props.headLineTypePlural}
                    data={{
                      header: item[0],
                      count: item[1].length,
                    }}
                  />
                )}
                {item?.[1] &&
                  item?.[1].map((itm: any, index: number) => (
                    <InfoCard
                      type="shop"
                      key={index}
                      data={{
                        ...itm,
                        bottomText: bottomTextCreator(itm),
                        topText: topTextCreator(itm),
                      }}
                      onClick={() => {
                        pathCreator && history.push(pathCreator(itm));
                      }}
                    >
                      <InfoCard.EndArea thirdGrid={12}>
                        {threeDotMenuItems && (
                          <div
                            style={{
                              width: "100%",
                              textAlign: "end",
                            }}
                          >
                            <ThreeDotMenuItem
                              threeDotMenuItems={threeDotMenuItems}
                              itm={itm}
                            />
                          </div>
                        )}
                      </InfoCard.EndArea>
                    </InfoCard>
                  ))}
              </div>
            ))}
        </>
      )}
    </div>
  );
});
const useStyles = makeStyles({
  component: {
    display: "flex",
    flexDirection: "column",
  },
  noRecordsFound: {
    display: "flex",
    paddingLeft: "24px",
  },
  threeDot: {
    width: 3,
    height: 3,
    borderRadius: "50%",
    backgroundColor: "grey",
    boxShadow: "0px 5px 0px grey, 0px 10px 0px grey",
  },
  cardImage: {
    borderRadius: 5,
    marginRight: 15,
  },
});
